import { axiosInstance } from "./AxiosInterceptor";
import { backendConfig } from "../config/BackendConfig";

/**
 * @param {
 * } queryParam
 * @returns Promise
 */
export const getSiteByTenantId = (queryParam) => {
  /**End Point:- getSiteByTenantId**/
  return axiosInstance.post(
    backendConfig.API_URL + backendConfig.API_END_POINTS.getSites,
    queryParam
  );
};
